var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductMockup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9445 7.58295V4.43018C16.9445 3.45101 16.5 3.05518 15.3959 3.05518H12.5903C11.4861 3.05518 11.0417 3.45101 11.0417 4.43018V7.57601C11.0417 8.56212 11.4861 8.95101 12.5903 8.95101H15.3959C16.5 8.95795 16.9445 8.56212 16.9445 7.58295Z",
    stroke: "#313233",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 11.6665V14.1665V16.6665",
    stroke: "#313233",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 14.1665H14.1667H16.6667",
    stroke: "#313233",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95838 7.58295V4.43018C8.95838 3.45101 8.51394 3.05518 7.40977 3.05518H4.60421C3.50005 3.05518 3.0556 3.45101 3.0556 4.43018V7.57601C3.0556 8.56212 3.50005 8.95101 4.60421 8.95101H7.40977C8.51394 8.95795 8.95838 8.56212 8.95838 7.58295Z",
    stroke: "#313233",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95838 15.3957V12.5901C8.95838 11.4859 8.51394 11.0415 7.40977 11.0415H4.60421C3.50005 11.0415 3.0556 11.4859 3.0556 12.5901V15.3957C3.0556 16.4998 3.50005 16.9443 4.60421 16.9443H7.40977C8.51394 16.9443 8.95838 16.4998 8.95838 15.3957Z",
    stroke: "#313233",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductMockup);
export default __webpack_public_path__ + "static/media/product-mockup.4995cbe62786666fff2c532bc49c3b45.svg";
export { ForwardRef as ReactComponent };